import { render, staticRenderFns } from "./msLiveLook.vue?vue&type=template&id=cfb05632&scoped=true"
import script from "./msLiveLook.vue?vue&type=script&lang=js"
export * from "./msLiveLook.vue?vue&type=script&lang=js"
import style0 from "./msLiveLook.vue?vue&type=style&index=0&id=cfb05632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb05632",
  null
  
)

export default component.exports